const PenIcon = ({ ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.6666 3.82666C13.6671 3.73892 13.6503 3.65194 13.6171 3.57072C13.5839 3.48949 13.535 3.41562 13.4733 3.35332L10.6466 0.526657C10.5843 0.46487 10.5104 0.415986 10.4292 0.38281C10.348 0.349634 10.261 0.332817 10.1733 0.333324C10.0855 0.332817 9.99855 0.349634 9.91733 0.38281C9.8361 0.415986 9.76222 0.46487 9.69993 0.526657L7.81326 2.41332L0.526596 9.69999C0.464809 9.76228 0.415925 9.83616 0.382749 9.91739C0.349573 9.99861 0.332756 10.0856 0.333263 10.1733V13C0.333263 13.1768 0.403501 13.3464 0.528525 13.4714C0.653549 13.5964 0.823119 13.6667 0.99993 13.6667H3.8266C3.91988 13.6717 4.01319 13.6571 4.10048 13.6238C4.18776 13.5905 4.26707 13.5393 4.33326 13.4733L11.5799 6.18666L13.4733 4.33332C13.5341 4.26871 13.5837 4.19435 13.6199 4.11332C13.6264 4.06018 13.6264 4.00646 13.6199 3.95332C13.623 3.92229 13.623 3.89102 13.6199 3.85999L13.6666 3.82666ZM3.55326 12.3333H1.6666V10.4467L8.2866 3.82666L10.1733 5.71332L3.55326 12.3333ZM11.1133 4.77332L9.2266 2.88666L10.1733 1.94666L12.0533 3.82666L11.1133 4.77332Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PenIcon;
